import React, { useEffect, useState, useContext, useCallback } from "react";

import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import GenericCard from "components/ui/cards/GenericCard";

import WithdrawItem from "features/accounting/withdraws/WithdrawItem";

import { StoreContext } from "shared/context/store-context";

const ContractWithdraws = ({ contract }) => {
  const { withdraws, InsertWithdraw } = useContext(StoreContext);

  const [loadedItem, setLoadedItem] = useState();

  const [currentWithdraws, setCurrentWithdraws] = useState();

  const fetchItem = useCallback(async () => {
    try {
      setLoadedItem(contract);
      const allWithdraws = withdraws.filter((item) => item.contract.id.toString() === contract.id);
      setCurrentWithdraws(allWithdraws);
    } catch (err) {}
  }, [contract, withdraws]);

  useEffect(() => {
    fetchItem();
  }, [contract, fetchItem]);

  return (
    <React.Fragment>
      {loadedItem && (
        <React.Fragment>
          <div className="form-container">
            <div className="horizontal-flex" style={{ justifyContent: "space-between" }}>
              <GenericCard
                dismissible={false}
                onDismiss={() => console.log("Kart kapatıldı")}
                style={{ paddingBottom: "0px" }}
              >
                <div style={{ flex: 1 }}>
                  <h4>Yeni İade</h4>
                  <div style={{ width: "600px", minHeight: "300px" }}>
                    <WithdrawItem fixedContract={contract} isNewItem={true} InsertItem={InsertWithdraw} />
                  </div>
                </div>
              </GenericCard>

              <div>
                <GenericCard
                  dismissible={false}
                  onDismiss={() => console.log("Kart kapatıldı")}
                  style={{ paddingBottom: "20px", width: "450px" }}
                >
                  <h4>İadeler</h4>
                  <TableContainer component={Paper} sx={{ width: 400 }}>
                    <Table sx={{ justifyContent: "flex-start" }}>
                      <TableHead>
                        <TableRow>
                          <TableCell>Tarih</TableCell>
                          <TableCell>Ödenen</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {currentWithdraws.map((row) => (
                          <TableRow key={row.id} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                            <TableCell component="th" scope="row">
                              {row.date}
                            </TableCell>
                            <TableCell>{row.amount}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </GenericCard>
              </div>
            </div>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default ContractWithdraws;
